import $ from 'jquery';
import { $accordion } from './variables';

if ($accordion.length) {

  $accordion.each(function () {
    if ($('.js__accordion_open_first', this).length) {
      let $first_elem = $('.js__accordion_trigger', this).first();
      let $icon = $(".icon", $first_elem);
      let $content = $first_elem.next();
      let height = $content.children().outerHeight() ?? 0;
      $content.css('height', height);
      $icon.removeClass('bg-ico-system-add');
      $icon.addClass('bg-ico-system-remove');
    }
  });

  $('.js__accordion_trigger').each(function () {

    $(this).on('click', function () {
      let $content = $(this).next();
      let $icon = $(".icon", this);
      let height = $content.children().outerHeight() ?? 0;

      if ($content.height() !== 0) {
        $content.css('height', '0');
        $icon.addClass('bg-ico-system-add');
        $icon.removeClass('bg-ico-system-remove');
      } else {
        $content.css('height', height);
        $icon.removeClass('bg-ico-system-add');
        $icon.addClass('bg-ico-system-remove');
      }

    });
  });
}